/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from 'react-i18next';

interface ContainerDetailsFooterProps {
  onBack: () => void;
}

const ContainerDetailsFooter = ({
  onBack,
}: ContainerDetailsFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-12 flex justify-between items-center">
          <button 
            onClick={onBack}
            className="flex items-center gap-3 px-8 py-3.5 text-[11px] font-black text-slate-500 uppercase tracking-widest border border-slate-200 rounded-xl hover:bg-slate-50 transition-all"
          >
            <span className="material-symbols-outlined text-2xl">{t('mediaPowder.icons.arrow_back')}</span>
            {t('containerInventory.containerBatchDetails.BacktoInventory')}
          </button>
          <div className="flex gap-4">
             <button className="px-8 py-3.5 bg-[#2D3E50] text-white rounded-xl text-[11px] font-black uppercase tracking-widest hover:brightness-110 shadow-lg shadow-slate-200 transition-all flex items-center gap-3 border-none outline-none focus:outline-none">
               <span className="material-symbols-outlined text-2xl">{t('containerInventory.icons.qr_code')}</span>
               {t('containerInventory.containerBatchDetails.PrintUnitTags')}
             </button>
             <button className="px-8 py-3.5 bg-[#FF7043] text-white rounded-xl text-[11px] font-black uppercase tracking-widest hover:brightness-110 shadow-lg shadow-orange-500/20 transition-all flex items-center gap-3 border-none outline-none focus:outline-none">
               <span className="material-symbols-outlined text-2xl">{t('containerInventory.icons.history')}</span>
               {t('containerInventory.containerBatchDetails.ViewAuditTrail')}
             </button>
          </div>
        </div>
  );
};

export default ContainerDetailsFooter;